import { Card, Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWrench,
  faProjectDiagram,
  faImages,
  faLocationDot,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import './Community.css';

const communityServices = [
  {
    title: 'Maintenance',
    description:
      'View plot maintenance schedules, cleaning updates, and photo galleries of maintained plots.',
    icon: faWrench,
    path: '/maintenance',
    color: '#2ecc71',
  },
  {
    title: 'Projects',
    description:
      'Explore ongoing and upcoming community development projects and initiatives.',
    icon: faProjectDiagram,
    path: '/projects',
    color: '#3498db',
  },
  {
    title: 'Gallery',
    description:
      'Browse through photos of our beautiful community, events, and celebrations.',
    icon: faImages,
    path: '/gallery',
    color: '#9b59b6',
  },
  {
    title: 'Near By Locality',
    description:
      'Discover amenities, landmarks, and essential services in the surrounding area.',
    icon: faLocationDot,
    path: '/nearby-locality',
    color: '#e74c3c',
  },
];

const Community = () => {
  return (
    <Container fluid className="community-container py-4">
      <div className="community-header mb-4">
        <h3>Our Community Services</h3>
        <p className="lead text-muted">
          Explore the various services and features available to our community
          members
        </p>
      </div>

      <Row className="g-4">
        {communityServices.map((service) => (
          <Col key={service.title} xs={12} md={6}>
            <Link to={service.path} className="text-decoration-none">
              <Card className="community-card h-100">
                <Card.Body className="d-flex flex-column">
                  <div
                    className="service-icon-wrapper mb-3"
                    style={{ backgroundColor: `${service.color}20` }}
                  >
                    <FontAwesomeIcon
                      icon={service.icon}
                      className="service-icon"
                      style={{ color: service.color }}
                    />
                  </div>
                  <Card.Title className="service-title">
                    {service.title}
                  </Card.Title>
                  <Card.Text className="text-muted flex-grow-1">
                    {service.description}
                  </Card.Text>
                  <div
                    className="mt-3 d-flex align-items-center explore-link"
                    style={{ color: service.color }}
                  >
                    <span>Explore</span>
                    <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
                  </div>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>

      <div className="community-guide mt-5 p-4 bg-light rounded">
        <h4 className="mb-3">Quick Navigation Guide</h4>
        <ul className="guide-list">
          <li>
            <strong>Maintenance:</strong> Check plot cleaning schedules and view
            maintenance photos
          </li>
          <li>
            <strong>Projects:</strong> Stay updated with community development
            initiatives
          </li>
          <li>
            <strong>Gallery:</strong> View community photos and event memories
          </li>
          <li>
            <strong>Near By Locality:</strong> Find nearby amenities and
            services
          </li>
        </ul>
      </div>
    </Container>
  );
};

export default Community;
